import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import CartNotification from 'components/navbar/top/CartNotification';
//import NotificationDropdown from 'components/navbar/top/NotificationDropdown';
import ProfileDropdown from 'components/navbar/top/ProfileDropdown';
import AppContext from 'context/Context';
import React, { useContext } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NineDotMenu from './NineDotMenu';
import { useTranslation } from 'react-i18next';
import JavaScritpTester from 'y4/components/navbar/top/JavaScritpTester';
import LoginButton from 'y4/components/navbar/top/LoginButton';
const TopNavRightSideNavItem = () => {
  const { t } = useTranslation('setting');

  const {
    config: { isDark, isRTL },
    setConfig
  } = useContext(AppContext);

  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <Nav.Item as={'li'}>
        <Nav.Link
          className="px-2 theme-control-toggle"
          onClick={() => setConfig('isDark', !isDark)}
        >
          <OverlayTrigger
            placement={isRTL ? 'bottom' : 'left'}
            overlay={
              <Tooltip>
                {isDark
                  ? t('Switch to light theme')
                  : t('Switch to dark theme')}
              </Tooltip>
            }
          >
            <div className="theme-control-toggle-label">
              <FontAwesomeIcon
                icon={isDark ? 'sun' : 'moon'}
                className="fs-0"
              />
            </div>
          </OverlayTrigger>
        </Nav.Link>
      </Nav.Item>
      <JavaScritpTester />
      {/**
      <CartNotification />
      <NotificationDropdown />
      */}
      <NineDotMenu />
      <ProfileDropdown />
      <LoginButton />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
